import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question, StaticMethods} from '../../model/GeneralModels';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-checkbox-field',
  template: `
    <mat-card *ngIf="!hasChildren" [ngClass]="hasFather ? 'mat-card-no-border' : ''" [formGroup]="Group">
      <mat-checkbox (change)="onChangeCallback($event)" id="{{fieldName}}"
                    formControlName="{{fieldName}}">
        {{fieldLabel}}
      </mat-checkbox>
    </mat-card>
    <mat-expansion-panel *ngIf="hasChildren" [expanded]="expandOpened" [formGroup]="Group" id="{{fieldName + '_expansion-panel'}}"
            (opened)="Group.controls[fieldName].patchValue(true)" (closed)="Group.controls[fieldName].patchValue(false)">
      <mat-expansion-panel-header>
        <mat-checkbox (change)="onChangeCallback($event)" class="disabled-pointer" id="{{fieldName}}" formControlName="{{fieldName}}">
          {{fieldLabel}}
        </mat-checkbox>
      </mat-expansion-panel-header>
      <app-form-list-generator [SingleThreads]="true" id="{{fieldName + '_child'}}" [questionList]="subList"
                               [Group]="Group" [noCheckBox]="false" [hasFather]="true" [productName]="productName">
      </app-form-list-generator>
    </mat-expansion-panel>
  `,
  styleUrls: [],
  styles: [`
    ::ng-deep .mat-checkbox-layout {
      white-space: normal !important;
    }
    ::ng-deep .mat-checkbox-inner-container {
         margin-top: 3px !important;
    }
    .disabled-pointer {
      pointer-events: none;
    }
    .mat-card-no-border {
      box-shadow: none;
    }
    /deep/ .mat-checkbox {
      font-family: inherit;
      font-weight: normal !important;
    }
    /deep/ .mat-card {
      text-align: right;
      margin: 7px 0;
      font-family: inharet;
    }
    mat-expansion-panel-header {
      height: max-content !important;
      min-height: 48px;
      padding: 0 18px;
      font-family: inharet;
    }
    mat-expansion-panel-content {
      font-family: inharet;
    }
    mat-expansion-panel {
      margin: 7px 0;
    }
    /deep/ label {
      font-weight: normal !important;
      text-align: right !important;
    }
    /deep/ .card {
      text-align: right !important;
    }
  `]
})
export class CheckboxFieldComponent implements OnInit, OnChanges {
  @Input() Group: FormGroup;
  @Input() fieldName: string;
  @Input() fieldLabel: string;
  @Input() disabled: boolean;
  @Input() icon: string;
  @Input() subList: Question[];
  @Output() OnChange = new EventEmitter<boolean>();
  @Input() even: boolean;
  @Input() hasFather = false;
  @Input() viewList: any = {};
  @Input() productName: string;
  @Input() value: any;
  hasChildren: boolean;
  expandOpened = false;
  constructor() {
  }

  ngOnInit() {
    if (!this.icon) {
      this.icon = 'icon ico-code-outline';
    }
    this.subList = this.subList || [];
    this.hasChildren = !!(this.subList.length);
  }

  onChangeCallback(event) {
    this.expandOpened = this.Group.controls[this.fieldName].value;
    this.viewList[this.fieldName] = this.Group.controls[this.fieldName].value;
    this.OnChange.emit(this.Group.controls[this.fieldName].value);
  }

  onExpansionChange(event) {
    if (this.expandOpened && !this.Group.controls[this.fieldName].value ||
      !this.expandOpened && this.Group.controls[this.fieldName].value) {
      this.Group.controls[this.fieldName].patchValue(this.expandOpened);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('prev value: ', this.value, changes);
    if (this.value) {
      this.expandOpened = StaticMethods.dynamicParse(this.value, 'number') === 1;
      this.Group.controls[this.fieldName].patchValue(StaticMethods.dynamicParse(this.value, 'number') === 1);
      this.onChangeCallback(this.value === 1);
    }
  }
}
